// extracted by mini-css-extract-plugin
module.exports = {"container":"CoursesPageLayout_container__nif3j","title":"CoursesPageLayout_title__romC1","desc":"CoursesPageLayout_desc__p5Z4C"};